// includes
// Note: this should always import before importing others
import "./includes/Bootstrap";

// deps
import ReactDOM from "react-dom";
import React from "react";

// components
import CheckoutApp from "./components/CheckoutApp";

const MOUNT_NODE = document.getElementById("root");

// ========================================================
//Render
// ========================================================
const render = <P extends Record<string, unknown>>(
    RootComponent: React.ComponentType<P>,
    hydrate: boolean,
    props: P,
): void => {
    if (!hydrate) {
        ReactDOM.render(React.createElement<P>(RootComponent, props), MOUNT_NODE);
        return;
    }

    if (typeof performance !== "undefined" && typeof performance.mark === "function") {
        performance.mark("checkout_hydration_start");
    }
    ReactDOM.hydrate(React.createElement<P>(RootComponent, props), MOUNT_NODE);
    if (typeof performance !== "undefined" && typeof performance.mark === "function") {
        performance.mark("checkout_hydration_end");
    }
};

// ========================================================
// This code is excluded from production bundle
// ========================================================
if (__HOT_RELOADING__) {
    if (module.hot) {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const { setConfig } = require("react-hot-loader");
        setConfig({ logLevel: "debug" });

        // Without this, private modules reload doesn't work..
        module.hot.accept();
        const moduleId: string = require.resolve("@swiggy-private/checkout-main");
        // Setup hot module replacement
        module.hot.accept(["./components/CheckoutApp", moduleId], () =>
            setImmediate(() => {
                MOUNT_NODE && ReactDOM.unmountComponentAtNode(MOUNT_NODE);
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                render(require("./components/CheckoutApp").default, false, {
                    apiHost: window.__API_HOST__,
                    paymentHost: window.__PAYMENT_HOST__,
                    analyticsHost: window.__ANALYTICS_HOST__,
                    headers: window.__headers__,
                    path: `${location.pathname}${location.search}`,
                });
            }),
        );
    }
}

render(CheckoutApp, true, {
    apiHost: window.__API_HOST__,
    paymentHost: window.__PAYMENT_HOST__,
    analyticsHost: window.__ANALYTICS_HOST__,
    simplPostLinkingRedirectUrl: window.__SIMPL_REDIRECT_URL__,
    headers: window.__headers__,
    path: `${location.pathname}${location.search}`,
});
